const DEBUG_MODE = true;

$(document).ready(function () {
  InitHomePageTileshow();
});

///////////////
// FUNCTIONS //
///////////////

// TILESHOW
function InitHomePageTileshow(timeout) {
  var tileshow = $(".tileshow");
  var paused = false;

  timeout = setInterval(function (paused) {
    var positionLocation = tileshow.attr("data-position");
    if (paused !== true) {
      MoveHomepageTileshowWithTimer(tileshow, positionLocation);
    }
  }, 6000);

  $(".tileshow li").click(function (evt) {
    var tileshow = $(".tileshow");
    var positionTarget = $(this).attr("data-index");
    var paused = true;

    if (positionTarget == 1) {
      $(".tileshow .tile .image-text").hide();
      tileshow.attr("data-position", "A");
      $('.tileshow .tile[data-tile-index="1"] .image-text')
        .delay(3000)
        .fadeIn(10);
    } else if (positionTarget == 2) {
      $(".tileshow .tile .image-text").hide();
      tileshow.attr("data-position", "B");
      $('.tileshow .tile[data-tile-index="2"] .image-text')
        .delay(3000)
        .fadeIn(10);
    } else if (positionTarget == 3) {
      $(".tileshow .tile .image-text").hide();
      tileshow.attr("data-position", "C");
      $('.tileshow .tile[data-tile-index="3"] .image-text')
        .delay(3000)
        .fadeIn(10);
    } else if (positionTarget == 4) {
      $(".tileshow .tile .image-text").hide();
      tileshow.attr("data-position", "D");
      $('.tileshow .tile[data-tile-index="4"] .image-text')
        .delay(3000)
        .fadeIn(10);
    }

    evt.preventDefault();
    clearInterval(timeout);
    timeout = setInterval(function (paused) {
      var positionLocation = tileshow.attr("data-position");
      if (paused !== true) {
        MoveHomepageTileshowWithTimer(tileshow, positionLocation);
      }
    }, 6000);
    return false;
  });
}

function MoveHomepageTileshowWithTimer(tileshow, positionLocation) {
  $(".tileshow .tile .image-text").hide();

  switch (positionLocation) {
    case "A":
      tileshow.attr("data-position", "B");
      idexTile = 2;
      break;
    case "B":
      tileshow.attr("data-position", "C");
      idexTile = 3;
      break;
    case "C":
      tileshow.attr("data-position", "D");
      idexTile = 4;
      break;
    case "D":
      tileshow.attr("data-position", "A");
      idexTile = 1;
      break;
    default:
      tileshow.attr("data-position", "B");
      idexTile = 2;
      break;
  }

  $('.tileshow .tile[data-tile-index="' + idexTile + '"] .image-text')
    .delay(3000)
    .fadeIn(10);
}
